import React, { useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react'
import Empty from 'meinian-package/src/baseComponent/empty'
import { Spin } from 'antd'
import request from 'meinian-package/src/utils/request'
import { useRequest } from 'ahooks'
import isIPad from 'meinian-package/src/common/isIPad'
import ShopTop10 from '../shopTop10'
import PieAttrChart from '../../../component/pieAttrChart'
import { isHiddenStyleSourcePlatform } from '../../../component/filter/platform'
import styles from './index.module.less'

const normalizeSourceData = (result = {}) => {
  const sourceItems = result.pieCharts?.[0]?.items || []
  const normalizedItems = sourceItems
    .filter(item => !isHiddenStyleSourcePlatform(item.itemKey))
    .map(item => ({
      ...item,
      name: item.itemName,
      id: item.itemKey,
    }))
  const blogNum = normalizedItems.reduce((sum, item) => sum + Number(item.value || 0), 0)
  const items = normalizedItems.map(item => ({
    ...item,
    percentage: blogNum ? Number(((Number(item.value || 0) / blogNum) * 100).toFixed(2)) : 0,
  }))

  return { blogNum, items }
}

export default forwardRef(({ style, pieSourceType, baseParams }, ref) => {
  const [data, setData] = useState({})
  const sourceTopData = useRef(null)
  const [parentData, setParentData] = useState({
    color: '#6B88FF',
    value: null,
    name: null,
  })

  const { loading, run, runAsync } = useRequest((_params) => request.get('/zhikuan/mn/collect-statistic/v2/platform-distribution', {
    params: _params,
  }), {
    manual: true,
    onSuccess: (result) => {
      setData(normalizeSourceData(result))
    }
  })

  useEffect(() => {
    run(baseParams)
  }, [])

  useImperativeHandle(ref, () => ({
    onUpdate: (_params) => fetchSource(_params)
  }))

  const fetchSource = (_params) => {
    runAsync({ ...baseParams, ..._params }).then(_data => {
      const { items } = normalizeSourceData(_data)
      if (items?.[0]?.itemKey) {
        sourceTopData.current?.onUpdate({
          ...baseParams,
          ..._params,
          platformId: items?.[0]?.itemKey,
        })
      }
    })
  }

  useEffect(() => {
    const _parentItem = data?.items?.find(item => +item.id === baseParams.platformId)
    if (_parentItem) {
      parentData.value = _parentItem.itemKey
    } else {
      parentData.name = data?.items?.[0]?.itemName
      parentData.value = data?.items?.[0]?.itemKey
    }
    setParentData(pre => ({ ...pre }))
  }, [baseParams.platformId, data])

  const onParentClick = (valObj) => {
    setParentData({ ...valObj, name: valObj.data.name, value: valObj.data.itemKey })
  }

  return (<div className={styles['meinian-source-analysis']} style={style}>
    <Spin spinning={loading}>
      {
        data?.items?.length ? <div className="meinian-source-analysis-group" style={{ display: `${isIPad ? 'block' : 'flex'}` }}>
          <PieAttrChart
            data={data?.items}
            centerText="采集来源占比"
            style={{ flex: 1 }}
            menuTitle={<div>款式来源分析<span style={{ marginLeft: '8px', color: 'var(--m-text-3)' }}>{data.blogNum}</span></div>}
            inspirationId={baseParams.inspirationId}
            sourceType={pieSourceType}
            onParentClick={onParentClick}
            menuClassName="meinian-source-analysis-pie-attr-menu"
            chartOption={{ style: { height: '288px', width: '288px', marginLeft: '60px' } }}
          />
          {/* 列表展示所有店铺、品牌、达人 */}
          <ShopTop10
            ref={sourceTopData}
            parentItem={parentData}
            platformOptions={baseParams.platformId
              ? data?.items.filter(item => +item.id === baseParams.platformId) : data?.items}
            baseParams={{
              ...baseParams,
              platformId: parentData.value
            }}
          />
        </div> : <Empty type="analysis" noPadding />
      }
    </Spin>
  </div>)
})
